(function coCuratorADA() {
  // Your code here
  let isOverlayVisible = false;
  let focusStack = [];
  function setIsOverlayVisible(value) {
    isOverlayVisible = value;
}

function getIsOverlayVisible() {
    return isOverlayVisible;
}

document.addEventListener('focusin', (event) => {
  const target = event.target;

  // if the target is a first-level or second-level item, we handle it
  if (target.matches('.mobile-menu__item, .mega-menu__linklist-link')) {

    // if it's a first-level item, we clear the stack
    if (target.matches('.mobile-menu__item')) {
      focusStack = [];
    }

    focusStack.push(target);
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    const lastFocused = focusStack.pop();
    // this means we are WITHIN a popup menu
    if (lastFocused && lastFocused.matches('.mega-menu__linklist-link')) {
      // We were inside a submenu, we close it
      console.log('submenu')
      lastFocused.closest('.mobile-submenu__list').style.display = 'none';
    } else {
      // We were in the main menu, is this mobile or desktop?
      closeMenus();
    }
    
    if (focusStack.length > 0) {
      // focus the last element in the stack
      focusStack[focusStack.length - 1].focus();
    }
  }
});

  document.addEventListener(
    'focus',
    function (event) {
      const currentElement = event.target;
      const previousElement = event.relatedTarget;
      const triggeredBy = document.activeElement;
      checkCloseMiniCart(previousElement, currentElement) == true
      console.log('Element focused:', currentElement);
      console.log(event);
    },
    true
  );
  observeAndUpdateTitle('dummy-chat-button-iframe', changeElementTitle, 'Shopify online store chat')

    function checkCloseMiniCart(previousElement, currentElement){
      const ajaxCart = document.getElementById('theme-ajax-cart')
      if(ajaxCart && ajaxCart.contains(currentElement)){
        console.log("keep ajax car open")
        ajaxCart.scrollTop = currentElement.offsetTop - ajaxCart.offsetTop;
      }
      if (ajaxCart && ajaxCart.contains(previousElement) && !ajaxCart.contains(currentElement)) {
        console.log("close ajax cart");
        closeMenus()
      }
    }

  function handleButtonBlur(event, container) {
    console.log('handleButtonBlur function called');
    console.log('Event target:', event.target);
    
    const focusedElement = event.target;
    
    if (focusedElement && focusedElement.matches('.mega-menu__linklist-link')) {
      // We were inside a submenu, we close it
      console.log('submenu!!');
      focusedElement.closest('.mobile-submenu__list').style.display = 'none';
    }
    // Rest of your code handling focus behavior after the blur event
  }

function closeMenus(){
  const isMobile = !window.PXUTheme.media_queries.large.matches
  if(isMobile){
    // is this menu, search, cart, or ...
    let mobileMenu = document.querySelector('[data-show-mobile-menu]');
    let mobieMenuIsOpen = mobileMenu.dataset.showMobileMenu === 'true' ? true : false;
    let mobileAjax = document.querySelector('.mobile-icons').querySelector('.header-cart__toggle-button');
    let mobileAjaxIsOpen = mobileAjax.getAttribute('aria-expanded') === 'true' ? true : false;
    // let mobileSearch = document.querySelector('.mobile-search');
    // let mobileSearchIsOpen = mobileSearch.getAttribute('aria-expanded') === 'true'  ? true : false;
      if(mobieMenuIsOpen){
        mobileMenuToggle();
        window.PXUTheme.mobileMenu.close();
        document.getElementById('mobile-menu_overlay').style.display = "none"
      }

      if(mobileAjaxIsOpen){
        window.PXUTheme.jsAjaxCart.hideMiniCart();
      }
      const mobileSearch = document.getElementById('mobile-search-new')

      if(mobileSearch){
        var element = document.getElementById('mobile-search-new');
        var style = window.getComputedStyle(element);
        var display = style.getPropertyValue('display');
        if(display === 'block') {
        const position = $(document).scrollTop();
        window.PXUTheme.predictiveSearch.hideMobileSearch(position);
        $('[data-autocomplete-true] .search__results-wrapper')
          .hide()
          .removeClass('results-found');
          document.getElementById('search-button-mobile').focus();
        }
      }


  }else{
    // we can be closing ajaxcart or search menu
    // is this menu, search, cart, or ...
    let ajaxCart = document.querySelector('.header-cart__toggle-button');
    let ajaxCartIsOpen = ajaxCart.getAttribute('aria-expanded') === 'true' ? true : false;
    if(ajaxCartIsOpen){
      window.PXUTheme.jsAjaxCart.hideMiniCart();
    }
    var element = document.querySelector('.search-popup');
    var style = window.getComputedStyle(element);
    var display = style.getPropertyValue('display');

    if(display === 'inline-block') {
      window.PXUTheme.jsHeader.hideSearch()
      setTimeout(function () {
            document.getElementById('search-button').focus();
      }, 0);
    } 
  }
}
  function toggleAjaxCart(trigger, isOpenOnly){
    const parentElement = trigger.parentElement
    const container = parentElement.querySelector('.theme-ajax-cart')
    let count = document.querySelector('[data-bind="itemCount"]').innerText.trim();
    trigger.setAttribute('aria-label', `${count} items in cart`);
    const isExpanded = isOpenOnly ? false : trigger.getAttribute('aria-expanded') === 'true';
    parentElement.classList.toggle('show-mini-cart', !isExpanded);
    trigger.setAttribute('aria-expanded', !isExpanded);
    // see if it is empty cart or not
    let subContainer;
    if(container.querySelector('.ajax-cart__empty-cart-message') && !isExpanded){
      if(container.querySelector('.ajax-cart__empty-cart-message').classList.contains('is-hidden')){
        subContainer = container .querySelector('.ajax-cart__form');
      }else{
        subContainer = container.querySelector('.ajax-cart__empty-cart-message');
      }
  
      trapFocus(subContainer, trigger)
    }

  }
  function closeAjaxCart(trigger){
    const parentElement = trigger.parentElement
    const container = parentElement.querySelector('.theme-ajax-cart')
    let count = document.querySelector('[data-bind="itemCount"]').innerText.trim();
    trigger.setAttribute('aria-label', `${count} items in cart`);
    parentElement.classList.toggle('show-mini-cart', false);
    trigger.setAttribute('aria-expanded', false);
    // see if it is empty cart or not
    trigger.focus();

  }


  function initMiniCartEvents() {
    const isMobile = !window.PXUTheme.media_queries.large.matches
    var trigger;
    if(!isMobile){
      trigger = document.querySelector('#action-icons .header-cart__toggle-button')
      trigger.addEventListener('click', function (e) {
        console.log(e.keyCode)
        // space or enter buttons
        if (e.keyCode === 32 || e.keyCode === 13) {
          // Prevent the default behavior of the event (e.g., scrolling the page)
          e.preventDefault();
        }
        toggleAjaxCart(trigger, false);
      });
    }
  }

  // handles all megamenu
  function megaMenuEvents($parentElement, $megaMenu) {
    // Convert the jQuery object to a NodeList
    const parentElement = $parentElement.get();
    const megaMenu = $megaMenu.get()[0];

    // Loop through each item
    for (const item of parentElement) {
      // Find the link, button, and section elements if they exist
      const linkElement = item.querySelector('a');
      const buttonElement = item.querySelector('button');
      const sectionElement = item.querySelector('section');

      // Perform any action on the link, button, or section
      if (linkElement) {
        linkElement.addEventListener('click', function (event) {
          sessionStorage.setItem('lastFocusedElement', event.target.id);
        });
      }
      if (buttonElement) {
        if (megaMenu) {
          // Add ARIA attributes to the button
          //buttonElement.setAttribute('aria-haspopup', 'menu');
          buttonElement.setAttribute('aria-expanded', 'false');
          //buttonElement.setAttribute('aria-controls', megaMenu.id);
          buttonElement.setAttribute(
            'aria-label',
            `${item.dataset.navlinkHandle} submenu`
          );
        } else {
          // If there is no mega menu, make the button ignored by the screen reader
          buttonElement.parentNode.removeChild(buttonElement);
        }

        buttonElement.addEventListener('click', function (event) {
          // Get the parent element and find the .mega-menu inside it
          const parent = event.currentTarget.parentNode;
          const megaMenu = parent.querySelector('.mega-menu');

          // Create the sr-only div if it doesn't exist
          let menuStatus = parent.querySelector('.sr-only');
          if (!menuStatus) {
            menuStatus = document.createElement('div');
            menuStatus.classList.add('sr-only');
            menuStatus.setAttribute('tabindex', '-1');
            menuStatus.setAttribute('role', 'presentation');
            menuStatus.setAttribute('aria-live', 'polite');
            buttonElement.insertAdjacentElement('afterend', menuStatus);
          }
          if (megaMenu) {
            // Toggle the mega menu display
            const isMenuVisible = megaMenu.classList.contains('mega-menu-open');
            if (!isMenuVisible) {
              // Add a keydown event listener to the focusable elements inside the mega menu
              const focusableElements = megaMenu.querySelectorAll(
                'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
              );

              focusableElements.forEach(element => {
                element.addEventListener('keydown', event => {
                  if (event.key === 'Escape') {
                    closeMegaMenuAndResetAttributes(buttonElement, megaMenu);
                    buttonElement.focus();
                  }
                });
              });

              // Attach a focusin event listener to check for focus changes
              if (!isMenuVisible) {
                attachFocusChangeListener(buttonElement, megaMenu);
              }
            }

            megaMenu.classList.toggle('mega-menu-open', !isMenuVisible);

            // Update the aria-expanded attribute
            event.currentTarget.setAttribute('aria-expanded', !isMenuVisible);
          }
        });

        buttonElement.addEventListener('keydown', function (event) {
          const parent = buttonElement.parentNode;
          const megaMenu = parent.querySelector('.mega-menu');

          if (
            event.key === 'Tab' &&
            megaMenu &&
            megaMenu.style.display === 'block'
          ) {
            // Set focus to the first focusable element within the displayed .mega-menu
            const focusableElements = megaMenu.querySelectorAll(
              'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
            );
            if (focusableElements.length > 0) {
              focusableElements[0].focus();
              event.preventDefault(); // Prevent the default tab behavior to avoid skipping the first focusable element
            }
          } else if (
            event.key === 'Escape' &&
            megaMenu &&
            megaMenu.classList.contains('mega-menu-open')
          ) {
            closeMegaMenuAndResetAttributes(buttonElement, megaMenu);
            buttonElement.focus();
          }
        });
        // Attach the same handler to the document to ensure it works even if the mega-menu was opened with a mouse hover
        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') {
            const megaMenu = document.querySelector('.mega-menu-open');
            var mobileMenuToggleButton = document.querySelector(
              '.mobile-menu__toggle-button'
            );

            if (megaMenu) {
              const buttonElement = megaMenu.previousElementSibling;
              closeMegaMenuAndResetAttributes(buttonElement, megaMenu);
              buttonElement.focus();
            }
            if (mobileMenuToggleButton) {
              var mobileMenu = document.querySelector('.mobile-menu');
              var mobileMenuItems =
                mobileMenu.querySelectorAll('.mobile-menu__item');
              window.PXUTheme.mobileMenu.close();
              closeMenu(mobileMenuToggleButton, mobileMenu, mobileMenuItems);
            }

            }

        });
        buttonElement.addEventListener('blur', function (event) {
          setTimeout(() => {
            // Close the mega menu if the focus has moved outside the mega menu or its parent element
            const megaMenu =
              buttonElement.parentElement.querySelector('.mega-menu');
            const activeElement = document.activeElement;

            if (
              megaMenu &&
              megaMenu !== activeElement &&
              !megaMenu.contains(activeElement) &&
              !parent.contains(activeElement)
            ) {
              megaMenu.style.display = 'none';

              // Reset the aria-expanded attribute
              buttonElement.setAttribute('aria-expanded', 'false');

              // Update the live region text
              // const menuStatus =
              //   buttonElement.parentElement.querySelector('.sr-only');
              // menuStatus.textContent = 'Menu has been closed.';
            }
          }, 100);
        });
      }
      if (sectionElement) {
        if (sectionElement.querySelector('.mega-menu') && buttonElement) {
          const ariaControlsValue = buttonElement.getAttribute('aria-controls');
          if (ariaControlsValue && sectionElement.querySelector('.mega-menu')) {
            sectionElement.querySelector('.mega-menu').id = ariaControlsValue;
          }
        }
      }
    }
  }

  function quantityBoxChange(event, action, totalLeft){
    //debugger
    const currentTarget = $(event.currentTarget)
    const parent = currentTarget.parents(`.quantity-wrapper`)
    let suffix = ''
    const isMobile = !window.PXUTheme.media_queries.large.matches
    if(isMobile){
      suffix = '-mobile'
    }
    let quantityInput = parent.find(`.quantity-input${suffix}`)
    const newValue = action == '-' ? parseInt(quantityInput.val())-1 : parseInt(quantityInput.val())+1

    const buttons = parent.find(`button`)
    buttons.each(function(){
      const button = $(this)
      if(action == '-'){
        if(button.hasClass('quantity-minus')){
          button.attr('aria-label', newValue-1 == 0 ? "decrease quantity (disabled)" : `decrease quantity to ${newValue-1}`)
        }
        if(button.hasClass('quantity-plus')){
          button.attr('aria-label', `increase quantity to ${newValue+1}`)
        }
    }
    if(action == '+'){
      if(button.hasClass('quantity-minus')){
        button.attr('aria-label', `decrease quantity to ${parseInt(newValue)-1}`)
      }
      if(button.hasClass('quantity-plus')){
        button.attr('aria-label', parseInt(newValue)+1 > totalLeft ? "increase quantity (disabled)" : `increase quantity to ${parseInt(newValue)+1}`)
      }
  }

  })}
  function closeMegaMenuAndResetAttributes(buttonElement, megaMenu) {
    megaMenu.classList.remove('is-active', 'mega-menu-open', 'hover-opened');
    buttonElement.setAttribute('aria-expanded', 'false');

    // const menuStatus = buttonElement.parentElement.querySelector('.sr-only');
    // menuStatus.textContent = 'Menu has been closed.';
    menuStatus.setAttribute('aria-hidden', 'true');
  }

  function attachFocusChangeListener(buttonElement, megaMenu) {
    function focusChangeHandler(event) {
      if (!megaMenu.contains(event.target)) {
        closeMegaMenuAndResetAttributes(buttonElement, megaMenu);
        document.removeEventListener('focusin', focusChangeHandler);
      }
    }

    document.addEventListener('focusin', focusChangeHandler);
  }


  function breadcrumbsCurrentPage() {
    // First, remove the aria-current=page from existing <li>
    const listItems = $('.breadcrumb').find('li');
    for (let listItem of listItems) {
      let anchor = $(listItem).find('a').first();
      if (anchor.attr('aria-current') == 'page') {
        anchor.removeAttr('aria-current');
      }
    }
    // Then get the last non hidden <li> and add the aria-current='page' to it.
    const lastItem = $('.breadcrumb')
      .find('li:not(.is-hidden)')
      .last()
      .find('a');
    if (lastItem.length > 0) {
      lastItem.attr('aria-current', 'page');
    } else {
      console.log('no breadcrumbs located');
    }
  }

  function updateCartItemQuantity(event) {
    const newQuantity = event.target.value;
    const itemRow = $(event.target).closest('tr');
    const price = Number(
      itemRow.find('.cart__item-final-price').text().replace('$', '')
    );
    const newTotal = newQuantity * price;
    const totalElement = itemRow.find('.cart_line-item-total');
    totalElement.text(`$${newTotal.toFixed(2)}`);
  }

  // Remove item from the cart
  function removeItemFromCart(event, selectorString = nul) {
    event.preventDefault();
    window.location.href='{{ routes.cart_change_url }}?line={{ forloop.index }}&amp;quantity=0'
    setTimeout(() => {
      const itemRows = $('.cart__items-tbody');
      if ((itemRows.length = 1)) {
        selectorString = '#cart-item-0-product';
      }
      if (selectorString != null) {
        changeFocusElement(event, selectorString);
      }
    }, 1000);
  }



  // Use this function in an onclick event to change the focus based on an ajax parent selector and ajax child selector.
  // If parent selector is present, a parent of the currentTarget matching the selector will be selected.
  // Then a child of that selected parent will be selected and given focus.
  // If parentSelector is not present, the entire document will be seached.
  function changeFocusElement(event, elementSelector, parentSelector = null) {
    const currentTarget = $(event.currentTarget);
    if (parentSelector == null) {
      $(`${elementSelector}`).first().focus();
    } else {
      const parent = currentTarget.parents(`${parentSelector}`);

      parent.find(`${elementSelector}`).first().focus();
    }
  }
  // mobile menu functions
  function mobileMenuToggle() {
    //var mobileMenuToggleButton = document.querySelector('.mobile-menu__toggle-icon');
    var mobileMenuToggleButton = document.querySelector(
      '.mobile-menu__toggle-button'
    );
    var mobileMenu = document.querySelector('.mobile-menu');
    var mobileMenuItems = mobileMenu.querySelectorAll('.mobile-menu__item');

    var isOpen =
      mobileMenuToggleButton.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      closeMenu(mobileMenuToggleButton, mobileMenu, mobileMenuItems);
    } else {
      openMenu(mobileMenuToggleButton, mobileMenu, mobileMenuItems);
    }
  }
  function openMenu(mobileMenuToggleButton, mobileMenu, mobileMenuItems) {
    mobileMenu.style.display = 'block';
    mobileMenu.setAttribute('aria-hidden', 'false');
    mobileMenuItems.forEach(function (item) {
      item.removeAttribute('tabindex');
    });
    mobileMenuToggleButton.focus();
    mobileMenuToggleButton.setAttribute('aria-expanded', 'true');
  }
  function closeMenu(mobileMenuToggleButton, mobileMenu, mobileMenuItems) {
    mobileMenu.style.display = 'none';
    mobileMenu.setAttribute('aria-hidden', 'true');
    mobileMenuItems.forEach(function (item) {
      item.setAttribute('tabindex', '-1');
    });

    mobileMenu.querySelectorAll('.mobile-submenu__list').forEach(function (e){
      e.style.display = "none";
    })
    document.getElementById('mobile-menu_overlay').style.display = "none";
    mobileMenuToggleButton.focus();
    mobileMenuToggleButton.setAttribute('aria-expanded', 'false');
  }
  // function initAccessibleMobileMenu() {

  //   var mobileMenu = document.querySelector('.mobile-menu');

  //   function handleEscapeKey(e) {
  //     var mobileMenuToggleButton = document.querySelector('.mobile-menu__toggle-icon');
  //     if (e.key === 'Escape' && mobileMenuToggleButton.getAttribute('aria-expanded') === 'true') {
  //       closeMenu();
  //     }
  //   }
  //   document.addEventListener('keydown', handleEscapeKey);
  // }
  function initMobileHeader($button) {
    // Convert the jQuery object to a DOM element
    let button = $button.get(0);
    button.addEventListener('click', function (e) {
      let closeDropdownButtons = document.querySelectorAll('.close-dropdown');
      closeDropdownButtons.forEach(function (otherButton) {
        if (otherButton !== button) {
          otherButton.setAttribute('aria-expanded', 'false');
          document.getElementById(`${otherButton.id}-content`).style.display = "none"
        }
      });

      // Set aria-expanded="true" for the clicked button
      button.setAttribute('aria-expanded', 'true');

      // Toggle the display of the child element with [data-mobile-submenu-first-level-list]
      let parent = button.parentElement.parentElement;
      let list = parent.querySelector(
        '[data-mobile-menu-has-toggle] [data-mobile-submenu-first-level-list]'
      );
      if (list) {
        list.style.display = list.style.display === 'none' ? 'block' : 'none';
      }
      // e.target.addEventListener('blur', (event) => {
      //   console.log('Blur event triggered');
      //   handleButtonBlur(event, list);
      // });
      trapFocus(list, e.target)
    });
  }

  function headerEvents() {
    if (document.querySelector('.search-form .close-search')) {
      document
        .querySelector('.search-form .close-search')
        .addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var position = window.scrollY;
          window.PXUTheme.predictiveSearch.hideMobileSearch(position);
          document.querySelector(
            '[data-autocomplete-true] .search__results-wrapper'
          ).style.display = 'none';
          // Check if we're on mobile or desktop
          var isMobile =
            window.getComputedStyle(document.getElementById('mobile-header'))
              .display !== 'none';
          var targetId = isMobile ? 'search-button-mobile' : 'search-button';
          // Set focus back to the search button
          document.getElementById(targetId).focus();
        });
    }


    document
      .getElementById('search-button')
      .addEventListener('click', function (e) {
        setTimeout(function () {
          const closeButton = document.querySelector(
            '.fancybox-button.fancybox-close-small'
          );
          if (closeButton) {
            closeButton.addEventListener('click', function (e) {
              e.preventDefault();
              document.getElementById('search-button').focus();
            });
          }
        }, 0);
      });
  }

  function rearrangeFeaturedProduct(jQueryElement, isDesktop) {
    if (jQueryElement == null || jQueryElement.length === 0) return;

    // If it's for desktop, adjust classes for all elements with class 'mega-menu__block'
    if (isDesktop) {
      // Get all elements with class 'mega-menu__block'
      const megaMenuBlocks = document.querySelectorAll('.mega-menu__block');

      // Iterate over each mega-menu block
      megaMenuBlocks.forEach(block => {
        // If it has the class 'one-fourth', remove it
        if (
          block.classList.contains('one-fourth') &&
          block.classList.contains('block__featured-product')
        ) {
          block.classList.remove('one-fourth');
        }
      });
    }

    // Iterate over each DOM element in the jQuery object
    jQueryElement.each(function () {
      // 'this' refers to the current DOM element in the iteration
      const domElement = this;

      // Find any featured product elements in the element
      const featuredProducts = domElement.querySelectorAll(
        '.block__featured-product'
      );

      // If there are any featured products...
      if (featuredProducts.length > 0) {
        // Create a new outer div element
        const div = document.createElement('div');
        //div.classList.add('mega-menu__block');

        // If it's for desktop, add 'one-half' to the new div
        if (isDesktop) {
          div.classList.add('one-half');
        }
        div.classList.add('mega-menu__block_custom');

        // Create an h3 element with the text 'Featured Product'
        const h3 = document.createElement('h3');
        h3.textContent = 'Featured Products';
        h3.id = 'featured-product-title';
        h3.classList.add('mega-menu__block_title');

        // Append the h3 to the outer div
        div.appendChild(h3);

        // Create a new inner div element
        const innerDiv = document.createElement('div');

        // Apply a flex row layout to the inner div
        innerDiv.style.display = 'flex';
        innerDiv.style.flexDirection = 'row';
        innerDiv.style.alignItems = 'center';

        // If it's for desktop, adjust the justify-content style
        if (isDesktop) {
          innerDiv.style.justifyContent = 'space-between';
        } else {
          innerDiv.style.justifyContent = 'center';
        }

        // Move each featured product to the new inner div
        featuredProducts.forEach(featuredProduct => {
          if (isDesktop) {
            featuredProduct.classList.add('one-half');
          }
          // Remove the featured product from its current parent
          featuredProduct.parentNode.removeChild(featuredProduct);

          // Append it to the new inner div
          innerDiv.appendChild(featuredProduct);
        });

        // Append the inner div to the outer div
        div.appendChild(innerDiv);

        // Find the container element within the domElement
        const container = domElement.querySelector(
          '.container.has-no-side-gutter'
        );

        // Append the new div to the container
        if (container) {
          container.appendChild(div);
        }
      }
    });
  }
  // this function will only add to main header mobile and desktop and then scroll up when add
  // function processItems(items) {
  //   const headerStickyWrapper = $('#header-sticky-wrapper');
  //   const themeAjaxCart = $('.theme-ajax-cart');
  //   const scrollTop = $(window).scrollTop();
  //   const enableSticky = $('[data-enable_sticky="true"]').length > 0;

  //   const mobileHeaderItem = items.filter(function () {
  //     return $(this).parents('#mobile-header').length > 0;
  //   });

  //   let otherItem = null;

  //   items.each(function () {
  //     const item = $(this);

  //     if (!item.is(headerStickyWrapper)) {
  //       if (enableSticky) {
  //         const cartHeight = themeAjaxCart.outerHeight();
  //         const distanceFromTop = headerStickyWrapper.offset().top;

  //         if (scrollTop > distanceFromTop + cartHeight) {
  //           otherItem = headerStickyWrapper;
  //         } else {
  //           otherItem = themeAjaxCart;
  //         }
  //       }
  //     }
  //   });

  //   // Scroll to the top of the page
  //   $('html, body').animate({ scrollTop: 0 }, 'slow');

  //   return [mobileHeaderItem, otherItem];
  // }

  // this function will add the ajax cart on add to cart depending on where are in the page
  function processMiniCartItems(items) {
    const scrollTop = $(window).scrollTop();
    const enableSticky = $('[data-enable_sticky="true"]').length > 0;

    const mobileHeaderItem = items.filter(function () {
      return $(this).parents('#mobile-header').length > 0;
    });

    let otherItem = null;
    items.each(function () {
      const item = $(this);
      if (enableSticky) {
        const headerStickyWrapper = $('#header-sticky-wrapper');
        const themeAjaxCart = !window.PXUTheme.media_queries.large.matches ? $('#theme-ajax-cart-mobile'):$('#theme-ajax-cart');
        const cartHeight = themeAjaxCart.outerHeight();
        const distanceFromTop = headerStickyWrapper.offset().top;

        if (scrollTop > distanceFromTop + cartHeight) {
          otherItem = headerStickyWrapper;
        } else {
          otherItem = themeAjaxCart;
        }
      }
    });

    return [mobileHeaderItem.first(), $(otherItem)];
  }
  // SEARCH POPUP FUNCTION PREDICTIVE SEARCH LOGIC
  function predictiveSearchLiveRegion(resultCount) {
    // replace `#suggestionStatus` with the id of your live region element
    let liveRegion = document.getElementById('suggestionStatus');

    let message;
    if (resultCount > 0) {
      message = resultCount + ' results found.';
    } else {
      message = 'No results found.';
    }

    setTimeout(function () {
      liveRegion.textContent = message;
    }, 500);
  }

  function windowSize() {
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 798) {
        // If it's a desktop view, we hide the mobile header and show the desktop header
        document
          .getElementById('mobile-header')
          .setAttribute('aria-hidden', 'true');
        document.getElementById('header').setAttribute('aria-hidden', 'false');
      } else {
        // If it's a mobile view, we hide the desktop header and show the mobile header
        document
          .getElementById('mobile-header')
          .setAttribute('aria-hidden', 'false');
        document.getElementById('header').setAttribute('aria-hidden', 'true');
      }
    });

    // Trigger the handler initially on page load
    window.dispatchEvent(new Event('resize'));
  }
  function normalizeElement(element) {
    var normalizedElement;
  
    // If jQuery is defined and element is a jQuery object
    if (window.jQuery && element instanceof jQuery) {
        // Take the first element from jQuery object
        normalizedElement = element[0];
    } else if (element instanceof HTMLElement) {
        // If it's already a JavaScript DOM element, just use it as is
        normalizedElement = element;
    } else {
        throw new Error('Invalid element type');
    }

    return normalizedElement;
}
  // generic functions for trapping and untrapping element focus when dealing with popups etc:
  function trapFocus(container, searchInputId) {
    const normalizeEvent = normalizeElement(container)
    // Get the first and last tabbable elements
    var tabbableElements = normalizeEvent.querySelectorAll(
      'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
          );

    var firstTabStop = tabbableElements[0];
    var lastTabStop = tabbableElements[tabbableElements.length - 1];

    // Get the input element
    var inputElement = document.getElementById(searchInputId.id);
    // Listen for and trap the keyboard
    normalizeEvent.addEventListener('keydown', trapTabKey);
    function trapTabKey(e) {
      // Check for TAB key press
      if (e.keyCode === 9) {
        if (e.shiftKey) {
          /* shift + tab */ 
          if (document.activeElement === firstTabStop) {
            e.preventDefault();

            inputElement.focus(); // return to the input field
            if(normalizeEvent.id === 'mobile-menu_overlay'){
              mobileMenuToggle();
              window.PXUTheme.mobileMenu.close();
            }else if(firstTabStop.classList.contains('ajax-cart__cart-title')){
              // set true so it always closes the ajaxCart menu
              closeAjaxCart(document.activeElement);
              //toggleAjaxCart(document.activeElement, true)
            }
            else{
              normalizeEvent.style.display = 'none';
            }
          }
        } /* tab */ else {
          if (document.activeElement === lastTabStop) {
            e.preventDefault();
            inputElement.focus(); // return to the input field
            if(normalizeEvent.id === 'mobile-menu_overlay'){
              mobileMenuToggle();
              window.PXUTheme.mobileMenu.close();
            }else if(firstTabStop.classList.contains('ajax-cart__cart-title')){
              toggleAjaxCart(document.activeElement, false)
            }
            else{
              normalizeEvent.style.display = 'none';
            }
              
          }
        }
      }
    }

    return trapTabKey;
  }

  function releaseFocus(container, trapTabKey) {
    // Remove keydown event from the container
    container[0].removeEventListener('keydown', trapTabKey);
  }
  // Remove item from the cart
  function removeItemFromCart(event, selectorString = nul) {
    event.preventDefault();
    setTimeout(() => {
      const itemRows = $('.cart__items-tbody');
      if ((itemRows.length = 1)) {
        selectorString = '#cart-item-0-product';
      }
      if (selectorString != null) {
        changeFocusElement(event, selectorString);
      }
    }, 1000);
  }

  function productLoopLiWidth(ulId) {
    const isMobile = !(window.innerWidth >= 798);
    const productLoopUl = document.querySelector(`#${ulId}`);
    console.log(productLoopUl)
    if (!productLoopUl) {
      console.error(`Element with ID '${ulId}' not found.`);
      return;
    }
  
    const productsPerRow = isMobile
      ? productLoopUl.dataset.products_per_row_mobile
      : productLoopUl.dataset.products_per_row;
    
    console.log("productsPerRow: ", productsPerRow);
    
    const widthFloat = 100 / parseInt(productsPerRow, 10) + "%";
    console.log(widthFloat);
    
    const listItems = productLoopUl.querySelectorAll("li");
  
    console.log(listItems); // Log the listItems node list
    for (let i = 0; i < listItems.length; i++) {
      listItems[i].style.width = widthFloat;
      console.log(listItems[i]);
    }
  }
  
  function observeAndUpdateTitle(targetElementId, callback, newTitle) {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        for (const addedNode of mutation.addedNodes) {
          if (addedNode.id === targetElementId) {
            // Call the callback function with the added element as an argument
            callback(addedNode, newTitle);
  
            // Disconnect the observer after the target element is found
            observer.disconnect();
          }
        }
      }
    });
  
    const observerOptions = {
      childList: true,
      subtree: true,
    };
  
    observer.observe(document, observerOptions);
  }

  function changeElementTitle(element, newTitle) {
    console.log(`Element with ID '${element.id}' is added to the DOM.`);
    // Set the new title for the added element
    element.title = newTitle;
    // Do something with the added element, e.g., modify its content or style
  }
  
  function fancyboxThumbsListener(event){
    console.log('currentTarget: ', event.currentTarget)
    let thumbsOpening = true;
    const fancyboxContainers = document.getElementsByClassName('fancybox-container')
    for(let container of fancyboxContainers){
      if(container.classList.contains('fancybox-show-thumbs')){
        // If it finds the thumbs are open, it means its going to close.
        thumbsOpening = false
        break
      }
    }
    thumbsOpening == true ? event.currentTarget.setAttribute('aria-expanded', 'true') : event.currentTarget.setAttribute('aria-expanded', 'false')

  }


  // ---------------------------------------------------------------
  // RM pre-order purchase limit (BP 2026-10-01)
  // Keeps PDP forms flagged with [data-rm-limit-form] in sync with the
  // cart after ajax cart changes: the quantity box caps at the remaining
  // allowance and the form flips to .rm-limit-reached once the cart holds
  // the limit. Liquid renders the initial state server-side; the Museum OS
  // checkout validation function enforces the same rule at checkout.
  // ---------------------------------------------------------------
  function rmLimitSync() {
    const forms = document.querySelectorAll('[data-rm-limit-form]');
    if (!forms.length) return;

    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then((response) => (response.ok ? response.json() : null))
      .then((cart) => {
        if (!cart || !Array.isArray(cart.items)) return;

        forms.forEach((form) => {
          const productId = Number(form.getAttribute('data-product-id'));
          const limitTotal =
            Number(form.getAttribute('data-rm-limit-total')) || 2;
          const inCart = cart.items
            .filter((item) => Number(item.product_id) === productId)
            .reduce((sum, item) => sum + Number(item.quantity || 0), 0);
          const remaining = Math.max(limitTotal - inCart, 0);

          form.classList.toggle('rm-limit-reached', remaining === 0);

          form.querySelectorAll('[data-rm-limit]').forEach((input) => {
            const max = Math.max(remaining, 1);
            input.setAttribute('max', max);
            input.setAttribute('data-rm-limit', max);
            if (Number(input.value) > max) {
              input.value = max;
            }
            if (
              typeof $ === 'function' &&
              window.PXUTheme &&
              window.PXUTheme.quantityBox
            ) {
              window.PXUTheme.quantityBox.updateQuantityControls($(input));
            }
          });
        });
      })
      .catch(() => {});
  }

  function initRmLimitSync() {
    if (!document.querySelector('[data-rm-limit-form]')) return;
    if (typeof $ === 'function') {
      $(document).ajaxSuccess(function (event, xhr, settings) {
        const url = settings && settings.url ? String(settings.url) : '';
        if (/\/cart\/(add|change|update|clear)\.js/.test(url)) {
          rmLimitSync();
        }
      });
    }
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) rmLimitSync();
    });
    rmLimitSync();
  }

  function publicFunction() {
    //console.log('This is a public function accessible from the global scope.');
  }

  // Attach the public function to the window object
  window.coCuratorADA = {
    megaMenuEvents: megaMenuEvents,
    mobileMenuToggle: mobileMenuToggle,
    initMobileHeader: initMobileHeader,
    rearrangeFeaturedProduct: rearrangeFeaturedProduct,
    processMiniCartItems: processMiniCartItems,
    predictiveSearchLiveRegion: predictiveSearchLiveRegion,
    trapFocus: trapFocus,
    releaseFocus: releaseFocus,
    toggleAjaxCart: toggleAjaxCart,
    changeFocusElement: changeFocusElement,
    updateCartItemQuantity: updateCartItemQuantity,
    removeItemFromCart: removeItemFromCart,
    breadcrumbsCurrentPage: breadcrumbsCurrentPage,
    quantityBoxChange: quantityBoxChange,
    productLoopLiWidth: productLoopLiWidth,
    fancyboxThumbsListener: fancyboxThumbsListener,
    handleButtonBlur: handleButtonBlur,
    closeAjaxCart: closeAjaxCart,
    setIsOverlayVisible: setIsOverlayVisible,
    getIsOverlayVisible: getIsOverlayVisible,
    rmLimitSync: rmLimitSync,
  };

  // Example: calling the private function
  breadcrumbsCurrentPage();
  windowSize();
  headerEvents();
  initMiniCartEvents();
  initRmLimitSync();
})();
